<template>
    <div class="bg-b">
      
        <div class="container" >
            <el-row :gutter="20">
                <el-col :sm="{span:16, offset:4}" :offset="0">
                    <el-card shadow="always" style="margin-top:20px; " :body-style="{ padding: '50px' }" v-loading="cargando">
                        <h1>Confirmar dirección de correo electrónico</h1>

                        <p>Su correo fue confirmado correctamente</p>
                    </el-card>

                </el-col>
                <el-col :span="12" :offset="0"></el-col>
            </el-row>

        </div>
    </div>
</template>

<script>
import {HTTP} from "@/axios"
export default {
    data() {
        return {
            cargando:true
        };
    },
    created()
    {
        this.confirmar(this.$route.query.c)
    },
    methods: {
        confirmar(docente)
        {
            HTTP.post('/docente/confirmaMail', { docente_id: docente })
                .then(res => {
                    this.cargando = false
                    if (res.data) {
                        this.$alert('Correo electronico confirmado', {
                            confirmButtonText: 'Aceptar',
                            type: 'success',
                            callback: () => {
                                this.$router.push({ name: 'capacitaciones' })
                            }
                        })

                    }
                    else {
                        this.$alert('No pudimos validar E-mail, refresque la página y reitente', {
                            confirmButtonText: 'Aceptar',
                            type: 'error',
                            callback: () => {
                                this.$router.push({ name: 'capacitaciones' })
                            }

                        })
                    }

                })
                .catch(() => {
                    this.cargando = false
                    this.$alert('No pudimos validar E-mail, refresque la página y reitente', {
                        confirmButtonText: 'Aceptar',
                        type: 'error',
                        callback: () => {
                            this.$router.push({ name: 'capacitaciones' })
                        }

                    })
                })
        }
    }
};
</script>

<style lang="scss" scoped>

</style>